interface SkeletonListProps {
  rows?: number;
}

export function SkeletonList({ rows = 5 }: SkeletonListProps) {
  return (
    <div className="space-y-0">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex gap-4 pb-4">
          <div className="skeleton-shimmer h-8 w-8 flex-shrink-0 rounded-full" />
          <div className="flex-1 space-y-2 pt-1">
            <div className="flex justify-between gap-4">
              <div className="skeleton-shimmer h-4 w-36 rounded" />
              <div className="skeleton-shimmer h-3 w-24 rounded" />
            </div>
            <div className="skeleton-shimmer h-3 w-28 rounded" />
          </div>
        </div>
      ))}
    </div>
  );
}
